<template>
  <div class="c-subject-nav">
    <!-- 初期表示時 -->
    <ul v-if="subjects.length < 1" class="c-subject-nav__list">
      <li
        v-for="s in SUBJECTS"
        :key="s.value"
        :class="{
          'c-subject-nav__list__item': true,
          ['c-subject-nav__list__item--' + s.value]: true,
        }"
      >
        <a href="#" class="disabledLink" aria-disabled="true" tabindex="-1" @click.prevent>
          <span class="label">{{ s.name }}</span>
        </a>
      </li>
    </ul>
    <!-- API 呼び出し後 -->
    <ul v-else class="c-subject-nav__list">
      <li
        v-for="s in subjects.filter(s => s.name in subjectNameToValue)"
        :key="s.name"
        :class="{
          'c-subject-nav__list__item': true,
          ['c-subject-nav__list__item--' + subjectNameToValue[s.name]]: true,
          'current': subjectNameToValue[s.name] === subject
        }"
      >
        <a v-if="!s.has_license" href="#" class="disabledLink" aria-disabled="true" tabindex="-1" @click.prevent>
          <span class="label">{{ s.name }}</span>
        </a>
        <a v-else @click.prevent="clickSubject(subjectNameToValue[s.name])" href="#">
          <span class="label">{{ s.name }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import { SUBJECTS } from "@/consts/subject";

  withDefaults(
    defineProps<{
      /** 選択中の教科識別子 (e.g. "rika") */
      subject?: string
      /** APIレスポンスの教科一覧。未取得の場合は空配列 */
      subjects?: Array<any>
    }>(),
    {
      subject: "",
      subjects: () => [],
    }
  )
  const emit = defineEmits<{
    (e: 'click', value: any): void
  }>()
  const subjectNameToValue: Record<string, string> = Object.fromEntries(SUBJECTS.map(s => [s.name, s.value]))

  function clickSubject(value) {
    emit('click', value)
  }
</script>

<style lang="scss" scoped>
  .disabledLink {
    pointer-events: none;
    background-color: rgba(233,233,233,.5);
    cursor: default;
    color: #ccc;
  }
</style>
